module.exports = __webpack_public_path__ + "img/list.4a1f5a3e.svg";